import { flattenContentfulObject } from '../services/contentful';
// ---------- FUNCTIONS ----------
export const getContentfulPages = async (contentfulClient) => {
    const response = await contentfulClient.getEntries({
        content_type: 'page',
        include: 6,
        limit: 1000
    });
    return response.items.map((p) => flattenContentfulObject(p));
};
//# sourceMappingURL=pages.js.map